var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import SearchResults from './searchresults';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import { fromLonLat } from 'ol/proj';
import { toLonLat } from 'ol/proj';
import flag from '../images/pin1.svg';
import { Icon, Style } from 'ol/style';
import Text from 'ol/style/Text';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import { Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import OSM from 'ol/source/OSM';
import ResItem from './resultitem';
import search from '../images/search.svg';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n    .ol-attribution {\n        display: none;\n    }\n"], ["\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n    .ol-attribution {\n        display: none;\n    }\n"])));
var idMap = 'mobilemap';
var MobileMapContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 2;\n    height: 100%;\n    border-radius: 33px;\n    overflow: hidden;\n\n\n    .ol-viewport {\n        border-radius: 33px;\n    }\n"], ["\n    flex: 2;\n    height: 100%;\n    border-radius: 33px;\n    overflow: hidden;\n\n\n    .ol-viewport {\n        border-radius: 33px;\n    }\n"])));
var SearchInput = styled.form(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: none;\n        border-bottom: 1px solid #FEFEFE;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: bold;\n        font-size: 30px;\n        line-height: 40px;\n        letter-spacing: -0.02em;\n        color: #FEFEFE;\n        padding-bottom: 14px;\n        background: transparent;\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"], ["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: none;\n        border-bottom: 1px solid #FEFEFE;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: bold;\n        font-size: 30px;\n        line-height: 40px;\n        letter-spacing: -0.02em;\n        color: #FEFEFE;\n        padding-bottom: 14px;\n        background: transparent;\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"])));
var SearchButton = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    background: url(", ") no-repeat center;\n    right: 0px;\n    top: 13px;\n    border: none;\n"], ["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    background: url(", ") no-repeat center;\n    right: 0px;\n    top: 13px;\n    border: none;\n"])), search);
var ResultsWrap = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n"], ["\n\n"])));
var initCoordinates = fromLonLat([4, 48]);
var layers1, mobmap, view = new View({
    center: initCoordinates,
    zoom: 12,
    //extent: [-1200000000, -20000000, 1200000000, 17000000],
    //enableRotation: false,
    //minZoom: 4
});
function createStyle(src, img, text) {
    return new Style({
        image: new Icon(({
            anchor: [0.3, 0.65],
            crossOrigin: 'anonymous',
            src: src,
            img: img,
            imgSize: img ? [img.width, img.height] : undefined,
        })),
        text: new Text({
            text: text,
            textAlign: 'left',
            offsetX: 15
        })
    });
}
var vl = new VectorLayer({
    map: mobmap,
    style: function (feature) {
        return feature.get('style');
    },
    name: 'Map',
    source: new VectorSource()
});
var flagVector = new VectorLayer({
    map: mobmap,
    style: function (feature) {
        return feature.get('style');
    },
    name: 'Flag',
    zIndex: 3,
    source: new VectorSource()
});
var iconFeature = new Feature(new Point(initCoordinates));
iconFeature.set('style', createStyle(flag, undefined, '4, 48'));
flagVector.getSource().addFeature(iconFeature);
// временно, для комбинации пресетов
layers1 = [
    new TileLayer({
        preload: 4,
        source: new OSM(),
    }),
    vl, flagVector
];
var useDebouncedEffect = function (effect, deps, delay) {
    useEffect(function () {
        var handler = setTimeout(function () { return effect(); }, delay);
        return function () { return clearTimeout(handler); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, __spreadArray(__spreadArray([], (deps || [])), [delay]));
};
export default function MapSearch(props) {
    var onSearchClick = props.onSearchClick, onCancelClick = props.onCancelClick, initPointId = props.initPointId, styleName = props.styleName;
    var mapRef = useRef(null);
    var _a = useState(''), searchText = _a[0], setSearchText = _a[1];
    var _b = useState(null), searchResults = _b[0], setSearchResults = _b[1];
    var _c = useState(false), test = _c[0], setTest = _c[1];
    var _d = useState(false), isResOpen = _d[0], toggleResOpen = _d[1];
    var _e = useState(''), coorText = _e[0], setCoorText = _e[1];
    var _f = useState(''), name1 = _f[0], setName = _f[1];
    var map2 = useState(new Map({
        target: null,
        layers: layers1,
        loadTilesWhileAnimating: true,
        view: view
    }))[0];
    var searchClick = function (e) {
        e.preventDefault();
        toggleResOpen(true);
        // e.stopPropagation();
        fetch("https://geocode-maps.yandex.ru/1.x/?apikey=acaa4a74-9f27-4305-be8d-b8fbb8e7e2e2&geocode=" + searchText + "&format=json")
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            if (data.error)
                return;
            var coll = data.response.GeoObjectCollection.featureMember;
            if (coll.length > 0) {
                // console.log(coll)
                var collSorted = coll.map(function (item, i) {
                    return React.createElement(ResItem, { key: i, isNoResult: false, name: item.GeoObject.name, description: item.GeoObject.description, coordinates: item.GeoObject.Point.pos, onClickRes: onClickRes });
                });
                setSearchResults(collSorted);
                return;
            }
            setSearchResults(null);
            return;
        });
    };
    var searchClick2 = function () {
        // e.preventDefault();
        // e.stopPropagation();
        // toggleResOpen(false)
        toggleResOpen(true);
        fetch("https://geocode-maps.yandex.ru/1.x/?apikey=acaa4a74-9f27-4305-be8d-b8fbb8e7e2e2&geocode=" + searchText + "&format=json")
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            if (data.error)
                return;
            var coll = data.response.GeoObjectCollection.featureMember;
            if (coll.length > 0) {
                // console.log(coll)
                var collSorted = coll.map(function (item, i) {
                    return React.createElement(ResItem, { key: i, item: item, isNoResult: false, name: item.GeoObject.name, description: item.GeoObject.description, coordinates: item.GeoObject.Point.pos, onClickRes: onClickRes });
                });
                setSearchResults(collSorted);
                return;
            }
            setSearchResults(null);
            return;
        });
    };
    useEffect(function () {
        map2.setTarget(idMap);
        /*
        let initCoordinates = fromLonLat([4, 45]);

        view = new View({
            center: initCoordinates,
            zoom: 12,
            extent: [-1200000000, -20000000, 1200000000, 17000000],
            enableRotation: false,
            minZoom: 4
        });
        */
        map2.on('singleclick', function (e) {
            var features = flagVector.getSource().getFeatures();
            features.forEach(function (feature) {
                flagVector.getSource().removeFeature(feature);
            });
            var iconFeatureClick = new Feature(new Point([e.coordinate[0], e.coordinate[1]]));
            var lonlatClick = toLonLat(e.coordinate);
            var lonlatClickX = lonlatClick[0];
            var lonlatClickY = lonlatClick[1];
            // mobmap.addLayer(vl)
            var featuresAfter = vl.getSource().getFeatures();
            featuresAfter.forEach(function (feature) {
                lonlatClick = toLonLat(feature.getGeometry().getCoordinates());
            });
            function ConvertDDToDMS(D) {
                return [0 | D, 'd ', 0 | (D < 0 ? D = -D : D) % 1 * 60, "' ", 0 | D * 60 % 1 * 60, '"'].join('');
            }
            iconFeatureClick.set('style', createStyle(flag, undefined, ConvertDDToDMS(lonlatClickX) + " \n " + ConvertDDToDMS(lonlatClickY)));
            flagVector.getSource().addFeature(iconFeatureClick);
            setSearchText(lonlatClickX + " " + lonlatClickY);
            // setTest(Math.random())
        });
        /*
        mobmap = new Map({
            target: idMap,
            layers: layers1,
            loadTilesWhileAnimating: true,
            view: view
        });
        */
        if (initPointId) {
            fetch("https://api.ffee.site/api/Point/Get?idPoint=" + initPointId)
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                console.log(data);
                onClickRes(data.latitude + " " + data.longitude, data.city[0].name, '');
                setName(data.name[0].name);
            });
        }
    }, []);
    useEffect(function () {
        console.log(test);
    }, [test]);
    /*
    useEffect(() => {
        if (searchText.length > 3) {
            searchClick2();
        }

        if (searchText.length === 0) {
            setCoorText('');
        }
    }, [searchText])
    */
    useDebouncedEffect(function () {
        if (searchText.match(/^\d+(?:[,.]\d+)?(?: \d+(?:[,.]\d+)?)*$/)) {
            setCoorText(searchText);
            toggleResOpen(false);
        }
        if (searchText.length > 3 && !searchText.match(/^\d+(?:[,.]\d+)?(?: \d+(?:[,.]\d+)?)*$/) && test === false) {
            searchClick2();
        }
        if (searchText.length === 0) {
            setCoorText('');
        }
    }, [searchText], 1000);
    var onClickRes = function (сoor, name, description) {
        setTest(true);
        var splittedCoordinates = сoor.split(' ').map(Number);
        // console.log(splittedCoordinates)
        var features = flagVector.getSource().getFeatures();
        features.forEach(function (feature) {
            flagVector.getSource().removeFeature(feature);
        });
        var lonlatClick = fromLonLat(splittedCoordinates);
        var lonlatClickX = lonlatClick[0];
        var lonlatClickY = lonlatClick[1];
        var iconFeatureClick = new Feature(new Point([lonlatClickX, lonlatClickY]));
        // mobmap.addLayer(vl)
        var featuresAfter = vl.getSource().getFeatures();
        featuresAfter.forEach(function (feature) {
            lonlatClick = toLonLat(feature.getGeometry().getCoordinates());
        });
        function ConvertDDToDMS(D) {
            return [0 | D, 'd ', 0 | (D < 0 ? D = -D : D) % 1 * 60, "' ", 0 | D * 60 % 1 * 60, '"'].join('');
        }
        iconFeatureClick.set('style', createStyle(flag, undefined, ConvertDDToDMS(lonlatClickX) + " \n " + ConvertDDToDMS(lonlatClickY)));
        flagVector.getSource().addFeature(iconFeatureClick);
        view.animate({
            center: fromLonLat(splittedCoordinates),
            duration: 1000
        });
        setSearchText(name);
        setCoorText(сoor);
        toggleResOpen(false);
        setTimeout(function () { return setTest(false); }, 1300);
        /*
        if (onSearchClick) {
            onSearchClick(сoor, name, description)
        }
        */
    };
    var onDoneClick = function (сoor, name, description) {
        if (onSearchClick) {
            onSearchClick(сoor, name, description);
        }
    };
    var onCancelClickEdited = function () {
        if (onCancelClick) {
            onCancelClick();
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Wrap, null,
            React.createElement(SearchResults, { searchClick: searchClick, searchText: searchText, setSearchText: setSearchText, searchResults: searchResults, setSearchResults: setSearchResults, onClickRes: onClickRes, isResOpen: isResOpen, name1: name1, setName: setName, coorText: coorText, onDoneClick: onDoneClick, onCancelClick: onCancelClickEdited, toggleResOpen: toggleResOpen, setTest: setTest, styleName: styleName }),
            React.createElement(MobileMapContainer, { key: 25, id: idMap, ref: mapRef })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
/*
const Wrap = styled.div`
    display: flex;
    width: 100%;

    .ol-attribution {
        display: none;
    }
`

const idMap = 'mobilemap';

const MobileMapContainer = styled.div`
    flex: 2;
    height: 700px;
    border-radius: 33px;
    overflow: hidden;
`;



export default function MapSearch(props) {

    const { mapClassName, onSearchClick, lang } = props;

    const mapRef = useRef(null);
    let initCoordinates = fromLonLat([4, 45]);
    let layers1, mobmap, view  = new View({
        center: initCoordinates,
        zoom: 12,
        extent: [-1200000000, -20000000, 1200000000, 17000000],
        enableRotation: false,
        minZoom: 4
    });

    useEffect(() => {

        /*
        view = new View({
            center: initCoordinates,
            zoom: 12,
            extent: [-1200000000, -20000000, 1200000000, 17000000],
            enableRotation: false,
            minZoom: 4
        });


        function createStyle(src, img) {
            return new Style({
                image: new Icon(({
                    anchor: [0.5, 1],
                    crossOrigin: 'anonymous',
                    src: src,
                    img: img,
                    imgSize: img ? [img.width, img.height] : undefined,
                }))
            });
        }




        let vl = new VectorLayer({
            map: mobmap,
            style: function(feature) {
                return feature.get('style');
            },
            name: 'Map',
            source: new VectorSource()
        })

        let flagVector = new VectorLayer({
            map: mobmap,
            style: function(feature) {
                return feature.get('style');
            },
            name: 'Flag',
            zIndex: 3,
            source: new VectorSource()
        })

        
        let iconFeature = new Feature(new Point(initCoordinates));
        iconFeature.set('style', createStyle(flag, undefined))
        flagVector.getSource().addFeature(iconFeature);


        // временно, для комбинации пресетов



        layers1 = [
            new TileLayer({
                preload: 4,
                source: new OSM()
            }),
            vl, flagVector
        ]


        mobmap = new Map({
            target: idMap,
            layers: layers1,
            loadTilesWhileAnimating: true,
            view: view
        });


    }, [])


    const onClickRes = (сoor, name, description) => {

        const splittedCoordinates = сoor.split(' ')

        view.animate({
            center: fromLonLat(splittedCoordinates),
            duration: 1000
        })

        if (onSearchClick) {
            onSearchClick(сoor, name, description)
        }
    }


    return <>
        <Wrap>
            <SearchResults lang={lang} onClickRes={onClickRes}/>
            <MobileMapContainer className={`${mapClassName}`} id={idMap} ref={mapRef}></MobileMapContainer>
        </Wrap>
    </>
}


        */ 
//# sourceMappingURL=map.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import SearchResults from './searchresults';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import { fromLonLat } from 'ol/proj';
import { toLonLat } from 'ol/proj';
import flag from '../images/pin1.svg';
import { Icon, Style } from 'ol/style';
import Text from 'ol/style/Text';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import { Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import OSM from 'ol/source/OSM';
import ResItem from './resultitem';
import search from '../images/search.svg';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n    .ol-attribution {\n        display: none;\n    }\n"], ["\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n    .ol-attribution {\n        display: none;\n    }\n"])));
var idMap = 'mobilemap';
var MobileMapContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 2;\n    height: 100%;\n    border-radius: 33px;\n    overflow: hidden;\n\n\n    .ol-viewport {\n        border-radius: 33px;\n    }\n"], ["\n    flex: 2;\n    height: 100%;\n    border-radius: 33px;\n    overflow: hidden;\n\n\n    .ol-viewport {\n        border-radius: 33px;\n    }\n"])));
var SearchInput = styled.form(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: none;\n        border-bottom: 1px solid #FEFEFE;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: bold;\n        font-size: 30px;\n        line-height: 40px;\n        letter-spacing: -0.02em;\n        color: #FEFEFE;\n        padding-bottom: 14px;\n        background: transparent;\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"], ["\n    display: block;\n    margin-bottom: 25px;\n    position: relative;\n    input[type=\"text\"] {\n        border: none;\n        border-bottom: 1px solid #FEFEFE;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: bold;\n        font-size: 30px;\n        line-height: 40px;\n        letter-spacing: -0.02em;\n        color: #FEFEFE;\n        padding-bottom: 14px;\n        background: transparent;\n        width: 100%;\n        box-sizing: border-box;\n        padding-right: 30px;\n        &:active, &:focus {\n            outline: none;\n        } \n    }\n\n"])));
var SearchButton = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    background: url(", ") no-repeat center;\n    right: 0px;\n    top: 13px;\n    border: none;\n"], ["\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    background: url(", ") no-repeat center;\n    right: 0px;\n    top: 13px;\n    border: none;\n"])), search);
var ResultsWrap = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n"], ["\n\n"])));
var initCoordinates = fromLonLat([4, 48]);
var layers1, mobmap, view = new View({
    center: initCoordinates,
    zoom: 12,
    //extent: [-1200000000, -20000000, 1200000000, 17000000],
    //enableRotation: false,
    //minZoom: 4
});
function createStyle(src, img, text) {
    return new Style({
        image: new Icon(({
            anchor: [0.3, 0.65],
            crossOrigin: 'anonymous',
            src: src,
            img: img,
            imgSize: img ? [img.width, img.height] : undefined,
        })),
        text: new Text({
            text: text,
            textAlign: 'left',
            offsetX: 15
        })
    });
}
var vl = new VectorLayer({
    map: mobmap,
    style: function (feature) {
        return feature.get('style');
    },
    name: 'Map',
    source: new VectorSource()
});
var flagVector = new VectorLayer({
    map: mobmap,
    style: function (feature) {
        return feature.get('style');
    },
    name: 'Flag',
    zIndex: 3,
    source: new VectorSource()
});
var iconFeature = new Feature(new Point(initCoordinates));
iconFeature.set('style', createStyle(flag, undefined, '4, 48'));
flagVector.getSource().addFeature(iconFeature);
// временно, для комбинации пресетов
layers1 = [
    new TileLayer({
        preload: 4,
        source: new OSM(),
    }),
    vl, flagVector
];
var useDebouncedEffect = function (effect, deps, delay) {
    useEffect(function () {
        var handler = setTimeout(function () { return effect(); }, delay);
        return function () { return clearTimeout(handler); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, __spreadArray(__spreadArray([], (deps || [])), [delay]));
};
export default function MapSearch(props) {
    var onSearchClick = props.onSearchClick, onCancelClick = props.onCancelClick, initPointId = props.initPointId, styleName = props.styleName;
    var mapRef = useRef(null);
    var _a = useState(''), searchText = _a[0], setSearchText = _a[1];
    var _b = useState(null), searchResults = _b[0], setSearchResults = _b[1];
    var _c = useState(false), test = _c[0], setTest = _c[1];
    var _d = useState(false), isResOpen = _d[0], toggleResOpen = _d[1];
    var _e = useState(''), coorText = _e[0], setCoorText = _e[1];
    var _f = useState(''), name1 = _f[0], setName = _f[1];
    var map2 = useState(new Map({
        target: null,
        layers: layers1,
        loadTilesWhileAnimating: true,
        view: view
    }))[0];
    var searchClick = function (e) {
        e.preventDefault();
        toggleResOpen(true);
        // e.stopPropagation();
        fetch("https://geocode-maps.yandex.ru/1.x/?apikey=acaa4a74-9f27-4305-be8d-b8fbb8e7e2e2&geocode=" + searchText + "&format=json")
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            if (data.error)
                return;
            var coll = data.response.GeoObjectCollection.featureMember;
            if (coll.length > 0) {
                // console.log(coll)
                var collSorted = coll.map(function (item, i) {
                    return React.createElement(ResItem, { key: i, isNoResult: false, name: item.GeoObject.name, description: item.GeoObject.description, coordinates: item.GeoObject.Point.pos, onClickRes: onClickRes });
                });
                setSearchResults(collSorted);
                return;
            }
            setSearchResults(null);
            return;
        });
    };
    var searchClick2 = function () {
        // e.preventDefault();
        // e.stopPropagation();
        // toggleResOpen(false)
        toggleResOpen(true);
        fetch("https://geocode-maps.yandex.ru/1.x/?apikey=acaa4a74-9f27-4305-be8d-b8fbb8e7e2e2&geocode=" + searchText + "&format=json")
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            if (data.error)
                return;
            var coll = data.response.GeoObjectCollection.featureMember;
            if (coll.length > 0) {
                // console.log(coll)
                var collSorted = coll.map(function (item, i) {
                    return React.createElement(ResItem, { key: i, item: item, isNoResult: false, name: item.GeoObject.name, description: item.GeoObject.description, coordinates: item.GeoObject.Point.pos, onClickRes: onClickRes });
                });
                setSearchResults(collSorted);
                return;
            }
            setSearchResults(null);
            return;
        });
    };
    useEffect(function () {
        map2.setTarget(idMap);
        /*
        let initCoordinates = fromLonLat([4, 45]);

        view = new View({
            center: initCoordinates,
            zoom: 12,
            extent: [-1200000000, -20000000, 1200000000, 17000000],
            enableRotation: false,
            minZoom: 4
        });
        */
        map2.on('singleclick', function (e) {
            var features = flagVector.getSource().getFeatures();
            features.forEach(function (feature) {
                flagVector.getSource().removeFeature(feature);
            });
            var iconFeatureClick = new Feature(new Point([e.coordinate[0], e.coordinate[1]]));
            var lonlatClick = toLonLat(e.coordinate);
            var lonlatClickX = lonlatClick[0];
            var lonlatClickY = lonlatClick[1];
            // mobmap.addLayer(vl)
            var featuresAfter = vl.getSource().getFeatures();
            featuresAfter.forEach(function (feature) {
                lonlatClick = toLonLat(feature.getGeometry().getCoordinates());
            });
            function ConvertDDToDMS(D) {
                return [0 | D, 'd ', 0 | (D < 0 ? D = -D : D) % 1 * 60, "' ", 0 | D * 60 % 1 * 60, '"'].join('');
            }
            iconFeatureClick.set('style', createStyle(flag, undefined, ConvertDDToDMS(lonlatClickX) + " \n " + ConvertDDToDMS(lonlatClickY)));
            flagVector.getSource().addFeature(iconFeatureClick);
            setSearchText(lonlatClickX + " " + lonlatClickY);
            // setTest(Math.random())
        });
        /*
        mobmap = new Map({
            target: idMap,
            layers: layers1,
            loadTilesWhileAnimating: true,
            view: view
        });
        */
        if (initPointId) {
            fetch("https://api.ffee.site/api/Point/Get?idPoint=" + initPointId)
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                console.log(data);
                onClickRes(data.latitude + " " + data.longitude, data.city[0].name, '');
                setName(data.name[0].name);
            });
        }
    }, []);
    useEffect(function () {
        console.log(test);
    }, [test]);
    /*
    useEffect(() => {
        if (searchText.length > 3) {
            searchClick2();
        }

        if (searchText.length === 0) {
            setCoorText('');
        }
    }, [searchText])
    */
    useDebouncedEffect(function () {
        if (searchText.match(/^\d+(?:[,.]\d+)?(?: \d+(?:[,.]\d+)?)*$/)) {
            setCoorText(searchText);
            toggleResOpen(false);
        }
        if (searchText.length > 3 && !searchText.match(/^\d+(?:[,.]\d+)?(?: \d+(?:[,.]\d+)?)*$/) && test === false) {
            searchClick2();
        }
        if (searchText.length === 0) {
            setCoorText('');
        }
    }, [searchText], 1000);
    var onClickRes = function (сoor, name, description) {
        setTest(true);
        var splittedCoordinates = сoor.split(' ').map(Number);
        // console.log(splittedCoordinates)
        var features = flagVector.getSource().getFeatures();
        features.forEach(function (feature) {
            flagVector.getSource().removeFeature(feature);
        });
        var lonlatClick = fromLonLat(splittedCoordinates);
        var lonlatClickX = lonlatClick[0];
        var lonlatClickY = lonlatClick[1];
        var iconFeatureClick = new Feature(new Point([lonlatClickX, lonlatClickY]));
        // mobmap.addLayer(vl)
        var featuresAfter = vl.getSource().getFeatures();
        featuresAfter.forEach(function (feature) {
            lonlatClick = toLonLat(feature.getGeometry().getCoordinates());
        });
        function ConvertDDToDMS(D) {
            return [0 | D, 'd ', 0 | (D < 0 ? D = -D : D) % 1 * 60, "' ", 0 | D * 60 % 1 * 60, '"'].join('');
        }
        iconFeatureClick.set('style', createStyle(flag, undefined, ConvertDDToDMS(lonlatClickX) + " \n " + ConvertDDToDMS(lonlatClickY)));
        flagVector.getSource().addFeature(iconFeatureClick);
        view.animate({
            center: fromLonLat(splittedCoordinates),
            duration: 1000
        });
        setSearchText(name);
        setCoorText(сoor);
        toggleResOpen(false);
        setTimeout(function () { return setTest(false); }, 1300);
        /*
        if (onSearchClick) {
            onSearchClick(сoor, name, description)
        }
        */
    };
    var onDoneClick = function (сoor, name, description) {
        if (onSearchClick) {
            onSearchClick(сoor, name, description);
        }
    };
    var onCancelClickEdited = function () {
        if (onCancelClick) {
            onCancelClick();
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Wrap, null,
            React.createElement(SearchResults, { searchClick: searchClick, searchText: searchText, setSearchText: setSearchText, searchResults: searchResults, setSearchResults: setSearchResults, onClickRes: onClickRes, isResOpen: isResOpen, name1: name1, setName: setName, coorText: coorText, onDoneClick: onDoneClick, onCancelClick: onCancelClickEdited, toggleResOpen: toggleResOpen, setTest: setTest, styleName: styleName }),
            React.createElement(MobileMapContainer, { key: 25, id: idMap, ref: mapRef })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
/*
const Wrap = styled.div`
    display: flex;
    width: 100%;

    .ol-attribution {
        display: none;
    }
`

const idMap = 'mobilemap';

const MobileMapContainer = styled.div`
    flex: 2;
    height: 700px;
    border-radius: 33px;
    overflow: hidden;
`;



export default function MapSearch(props) {

    const { mapClassName, onSearchClick, lang } = props;

    const mapRef = useRef(null);
    let initCoordinates = fromLonLat([4, 45]);
    let layers1, mobmap, view  = new View({
        center: initCoordinates,
        zoom: 12,
        extent: [-1200000000, -20000000, 1200000000, 17000000],
        enableRotation: false,
        minZoom: 4
    });

    useEffect(() => {

        /*
        view = new View({
            center: initCoordinates,
            zoom: 12,
            extent: [-1200000000, -20000000, 1200000000, 17000000],
            enableRotation: false,
            minZoom: 4
        });


        function createStyle(src, img) {
            return new Style({
                image: new Icon(({
                    anchor: [0.5, 1],
                    crossOrigin: 'anonymous',
                    src: src,
                    img: img,
                    imgSize: img ? [img.width, img.height] : undefined,
                }))
            });
        }




        let vl = new VectorLayer({
            map: mobmap,
            style: function(feature) {
                return feature.get('style');
            },
            name: 'Map',
            source: new VectorSource()
        })

        let flagVector = new VectorLayer({
            map: mobmap,
            style: function(feature) {
                return feature.get('style');
            },
            name: 'Flag',
            zIndex: 3,
            source: new VectorSource()
        })

        
        let iconFeature = new Feature(new Point(initCoordinates));
        iconFeature.set('style', createStyle(flag, undefined))
        flagVector.getSource().addFeature(iconFeature);


        // временно, для комбинации пресетов



        layers1 = [
            new TileLayer({
                preload: 4,
                source: new OSM()
            }),
            vl, flagVector
        ]


        mobmap = new Map({
            target: idMap,
            layers: layers1,
            loadTilesWhileAnimating: true,
            view: view
        });


    }, [])


    const onClickRes = (сoor, name, description) => {

        const splittedCoordinates = сoor.split(' ')

        view.animate({
            center: fromLonLat(splittedCoordinates),
            duration: 1000
        })

        if (onSearchClick) {
            onSearchClick(сoor, name, description)
        }
    }


    return <>
        <Wrap>
            <SearchResults lang={lang} onClickRes={onClickRes}/>
            <MobileMapContainer className={`${mapClassName}`} id={idMap} ref={mapRef}></MobileMapContainer>
        </Wrap>
    </>
}


        */ 
//# sourceMappingURL=map.js.map